/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BooleanResponseWrapper,
  ContestantDuplicateGroupDtoIReadOnlyListResponseWrapper,
  ContestantDuplicateGroupWithRegistrationsDtoIReadOnlyListResponseWrapper,
  ContestantDuplicateMergeRequestDto,
  ContestantDuplicateMergeResultDtoResponseWrapper,
  ContestantProfileDto,
  ContestantPublicProfileSearchRequest,
  ContestantUserBaseModel,
  ContestantUserModel,
  ContestantUserModelResponseWrapper,
  ContestantWinningBasicDto,
  ContestantWinningsSearchRequest,
  MoveRegistrationRequestDto,
  ProblemDetails,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ContestantUsers<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags ContestantUser
   * @name GetByContestantUserId
   * @request GET:/ContestantUsers/{contestantUserId}
   */
  getByContestantUserId = (contestantUserId: number, params: RequestParams = {}) =>
    this.request<ContestantUserModel, any>({
      path: `/ContestantUsers/${contestantUserId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name GetAllContestantUsers
   * @request GET:/ContestantUsers/GetAllContestantUsers
   */
  getAllContestantUsers = (params: RequestParams = {}) =>
    this.request<ContestantUserBaseModel[], any>({
      path: `/ContestantUsers/GetAllContestantUsers`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name GetAllContestantUsersBasicInfo
   * @request GET:/ContestantUsers/GetAllContestantUsersBasic
   */
  getAllContestantUsersBasicInfo = (params: RequestParams = {}) =>
    this.request<ContestantUserBaseModel[], any>({
      path: `/ContestantUsers/GetAllContestantUsersBasic`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name SaveContestantUser
   * @request POST:/ContestantUsers/Save
   */
  saveContestantUser = (data: ContestantUserModel, params: RequestParams = {}) =>
    this.request<ContestantUserModelResponseWrapper, any>({
      path: `/ContestantUsers/Save`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name AddContestantUser
   * @request POST:/ContestantUsers
   */
  addContestantUser = (data: ContestantUserBaseModel, params: RequestParams = {}) =>
    this.request<ContestantUserModelResponseWrapper, any>({
      path: `/ContestantUsers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name PatchContestantUser
   * @request PATCH:/ContestantUsers
   */
  patchContestantUser = (data: ContestantUserBaseModel, params: RequestParams = {}) =>
    this.request<ContestantUserModelResponseWrapper, any>({
      path: `/ContestantUsers`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name DeleteContestantUser
   * @request DELETE:/ContestantUsers
   */
  deleteContestantUser = (
    query?: {
      /** @format int32 */
      contestantUserId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/ContestantUsers`,
      method: 'DELETE',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name DuplicatesPingList
   * @request GET:/ContestantUsers/Duplicates/Ping
   */
  duplicatesPingList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ContestantUsers/Duplicates/Ping`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name DuplicatesSearchList
   * @request GET:/ContestantUsers/Duplicates/Search
   */
  duplicatesSearchList = (
    query?: {
      /** @format double */
      minSimilarity?: number;
      /** @format int32 */
      maxGroups?: number;
      /** @format int32 */
      maxCandidatesPerGroup?: number;
      exactOnly?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<ContestantDuplicateGroupDtoIReadOnlyListResponseWrapper, any>({
      path: `/ContestantUsers/Duplicates/Search`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name GetPotentialDuplicateContestantUsersWithRegistrations
   * @request GET:/ContestantUsers/Duplicates/WithRegistrations
   */
  getPotentialDuplicateContestantUsersWithRegistrations = (
    query?: {
      /** @format double */
      minSimilarity?: number;
      /** @format int32 */
      maxGroups?: number;
      /** @format int32 */
      maxCandidatesPerGroup?: number;
      exactOnly?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<ContestantDuplicateGroupWithRegistrationsDtoIReadOnlyListResponseWrapper, any>({
      path: `/ContestantUsers/Duplicates/WithRegistrations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name MergeDuplicateContestants
   * @request POST:/ContestantUsers/Duplicates/Merge
   */
  mergeDuplicateContestants = (data: ContestantDuplicateMergeRequestDto, params: RequestParams = {}) =>
    this.request<ContestantDuplicateMergeResultDtoResponseWrapper, any>({
      path: `/ContestantUsers/Duplicates/Merge`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name MoveRegistration
   * @request POST:/ContestantUsers/Move
   */
  moveRegistration = (data: MoveRegistrationRequestDto, params: RequestParams = {}) =>
    this.request<boolean, any>({
      path: `/ContestantUsers/Move`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name ContestantPublicWinningsSearch
   * @request POST:/ContestantUsers/winnings/public/search
   */
  contestantPublicWinningsSearch = (data: ContestantWinningsSearchRequest, params: RequestParams = {}) =>
    this.request<ContestantWinningBasicDto[], ProblemDetails>({
      path: `/ContestantUsers/winnings/public/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name ContestantPrivateWinningsSearch
   * @request POST:/ContestantUsers/winnings/private/search
   */
  contestantPrivateWinningsSearch = (data: ContestantWinningsSearchRequest, params: RequestParams = {}) =>
    this.request<ContestantWinningBasicDto[], ProblemDetails>({
      path: `/ContestantUsers/winnings/private/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name ContestantPublicProfilesFetchDynamic
   * @request POST:/ContestantUsers/fetch-public-profiles
   */
  contestantPublicProfilesFetchDynamic = (data: ContestantPublicProfileSearchRequest, params: RequestParams = {}) =>
    this.request<ContestantProfileDto[], any>({
      path: `/ContestantUsers/fetch-public-profiles`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name ContestantPublicProfile
   * @request GET:/ContestantUsers/{contestantUserId}/public-profile
   */
  contestantPublicProfile = (contestantUserId: number, params: RequestParams = {}) =>
    this.request<ContestantProfileDto, ProblemDetails>({
      path: `/ContestantUsers/${contestantUserId}/public-profile`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name ContestantPrivateProfilesFetchDynamic
   * @request POST:/ContestantUsers/fetch-private-profiles
   */
  contestantPrivateProfilesFetchDynamic = (data: ContestantPublicProfileSearchRequest, params: RequestParams = {}) =>
    this.request<ContestantProfileDto[], ProblemDetails>({
      path: `/ContestantUsers/fetch-private-profiles`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ContestantUser
   * @name ContestantPrivateProfile
   * @request GET:/ContestantUsers/{contestantUserId}/private-profile
   */
  contestantPrivateProfile = (contestantUserId: number, params: RequestParams = {}) =>
    this.request<ContestantProfileDto, ProblemDetails>({
      path: `/ContestantUsers/${contestantUserId}/private-profile`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
